import { render, staticRenderFns } from "./vendorAttach.vue?vue&type=template&id=24ce6c5c"
import script from "./vendorAttach.vue?vue&type=script&lang=js"
export * from "./vendorAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ce6c5c')) {
      api.createRecord('24ce6c5c', component.options)
    } else {
      api.reload('24ce6c5c', component.options)
    }
    module.hot.accept("./vendorAttach.vue?vue&type=template&id=24ce6c5c", function () {
      api.rerender('24ce6c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/vendorAttach.vue"
export default component.exports